import { useCallback, useEffect } from "react";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { useConfigFormState } from "../../../../common/ConfigForm/useConfigFormState";
import { listOptionSalesCustomer, listOptionCustomerGroup, createCustomerAsyn } from "../../../../../app/customerSlice";
import { useLoading } from "../../../../../hooks/useLoading";
import { LOADING_KEYS } from "../../../../../constants/loadingKeys";
import { hydrateBasicInfoForm } from "../basicInfo.payload";

const buildCreateCustomerPayload = (form) => {
  const payload = {
    accountGroup: form.accountGroup,
    customerName: form.customerName,
    phone: form.phone,
    address: {
      addressLine1: form.streetAddress,
      city: form.city,
      state: form.state,
      country: form.country,
      zipCode: form.postalCode,
    },
  };

  if (form.salesOfficeDescription) {
    payload.salesOfficeDescription = form.salesOfficeDescription;
  }

  return payload;
};

export const useCreateCustomerModal = () => {
  const dispatch = useDispatch();
  const { register, handleSubmit, errors, reset } = useForm();

  const salesOfficeOptions = useSelector((state) => state.customer.listOption);
  const customerGroupOptions = useSelector((state) => state.customer.customerGroupType);
  const saveLoading = useLoading(LOADING_KEYS.CREATE_CUSTOMER);

  const { form, setField } = useConfigFormState(() => ({ ...hydrateBasicInfoForm(undefined), accountGroup: "Z002" }));

  useEffect(() => {
    dispatch(listOptionSalesCustomer("salesoffice"));
    dispatch(listOptionCustomerGroup("customergroup"));
  }, [dispatch]);

  const onFieldChange = useCallback(
    (key, value) => {
      setField(key, value);
      if (key === "country") {
        setField("state", "");
      }
    },
    [setField]
  );

  const doSubmit = useCallback(async () => {
    await dispatch(createCustomerAsyn(buildCreateCustomerPayload(form)));
    reset();
  }, [form, dispatch, reset]);

  return {
    register,
    handleSubmit,
    errors,
    form,
    extra: { salesOfficeOptions, customerGroupOptions },
    onFieldChange,
    doSubmit,
    saveLoading,
  };
};
